import BaseTable from "../table/BaseTable";
import LeadCard from "./LeadCard";
import Button from "../ui/Button";

import { SendHorizontal } from "lucide-react";

import { useId } from "react";

import { useAuthStore } from "../../store/authStore";

export default function LeadsTable({ isMobile, leads, columns, handleResend }) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";
  const id = useId();
  if (isMobile) {
    return (
      <div className="leads-mobile-grid">
        {leads.map((lead, index) => (
          <LeadCard
            key={`${id}-${index}-lead-card`}
            lead={lead}
            handleResend={handleResend}
          />
        ))}
      </div>
    );
  }
  const expandedRowRender = (lead) => (
    <div className="lead-expanded">
      {/* 🔹 MINI LIST */}
      <div className="lead-row">
        <div>
          <span>Email:</span> {lead.email}
        </div>
        <div>
          <span>Timestamp:</span> {lead.timeline}
        </div>
        <div>
          <span>Conversation Time:</span> {lead.conversation_time} minutes
        </div>
        <div className="lead-actions">
          {isAdmin && (
            <Button
              onClick={() => handleResend?.(lead)}
              className="gap-1 d-flex align-center justify-center"
            >
              <SendHorizontal size={16} />
              Resend Lead
            </Button>
          )}
        </div>
      </div>

      {/* 🔹 ACTION */}
    </div>
  );

  return (
    <BaseTable
      columns={columns}
      data={leads}
      rowKey="id"
      expandable={{ expandedRowRender }}
    />
  );
}
